import { render, staticRenderFns } from "./FileDocumentView.vue?vue&type=template&id=38226602&"
import script from "./FileDocumentView.vue?vue&type=script&lang=js&"
export * from "./FileDocumentView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports